export default "__VITE_ASSET__BhhyVnvN__"